import type { SVGProps } from 'react';

export type FlagDEProps = SVGProps<SVGSVGElement> & {
  size?: number;
};

export const FlagDE = ({ size = 60, ...rest }: FlagDEProps) => (
  <svg
    width={size}
    height={size * (40 / 60)}
    viewBox="0 0 60 40"
    role="img"
    aria-label="Deutsch"
    {...rest}
  >
    <title>Deutsch</title>
    <rect x="1" y="1" width="58" height="12.667" fill="#1A1A1A" />
    <rect x="1" y="13.667" width="58" height="12.666" fill="#C8362C" />
    <rect x="1" y="26.333" width="58" height="12.667" fill="#E8B43C" />
    <rect
      x="1"
      y="1"
      width="58"
      height="38"
      fill="none"
      stroke="var(--color-ink)"
      strokeWidth="1.5"
    />
  </svg>
);
